// extracted by mini-css-extract-plugin
export default {"overlay":"SearchOverlay_overlay_XXrye"};